import { render, staticRenderFns } from "./EmptyProfileInfo.vue?vue&type=template&id=0885b022&scoped=true&"
import script from "./EmptyProfileInfo.vue?vue&type=script&lang=ts&"
export * from "./EmptyProfileInfo.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyProfileInfo.vue?vue&type=style&index=0&id=0885b022&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0885b022",
  null
  
)

export default component.exports